import { useTheme } from '@mui/material'

import { IconProps } from '@f-fertighaus/applications/Next/types/icon'

export const CakeIcon = (props: IconProps) => {
  const theme = useTheme()
  const stroke = props.color || theme.palette.primary.main
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1 9.5V13.5C1 14.605 4.134 15.5 8 15.5C11.866 15.5 15 14.605 15 13.5V9.5'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M8 9.5V6.5'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 4.5C10 2.5 8 0.5 8 0.5C8 0.5 6 2.5 6 4.5C6 5.60457 6.89543 6.5 8 6.5C9.10457 6.5 10 5.60457 10 4.5Z'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.5 7.6311C13.131 7.9191 15 8.6471 15 9.5001C15 10.6051 11.866 11.5001 8 11.5001C4.134 11.5001 1 10.6051 1 9.5001C1 8.6471 2.869 7.9191 5.5 7.6311'
        stroke={stroke}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
